import { request } from '@/utils'

export default {
  async findLeaders() {
    return request({
      path: '/leader'
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/about.js